import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { DeviceStateType } from '../reducer/device.reducer'

const state = (state: RootState) => state.deviceStore as DeviceStateType

export const selectIsEmbedded = createDraftSafeSelector(state, (store) => store.isEmbedded)
export const selectIsMobile = createDraftSafeSelector(state, (store) => store.isMobile)
export const selectIsTouchEnabled = createDraftSafeSelector(state, (store) => store.isTouchEnabled)